
// export type ListToTreeOptions = {
//     idKey?: string;
//     parentKey?: string;
//     childrenKey?: string;
// }

export const utilityService = {

    // base64: {
    //     _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
    //     encode(e: any) {
    //         let t = '', n, r, i, s, o, u, a, f = 0;
    //         e = this._utf8_encode(e);
    //         while (f < e.length) {
    //             n = e.charCodeAt(f++);
    //             r = e.charCodeAt(f++);
    //             i = e.charCodeAt(f++);
    //             s = n >> 2;
    //             o = (n & 3) << 4 | r >> 4;
    //             u = (r & 15) << 2 | i >> 6;
    //             a = i & 63;
    //             if (isNaN(r)) {
    //                 u = a = 64;
    //             } else if (isNaN(i)) {
    //                 a = 64;
    //             }
    //             t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
    //         }
    //         return t;
    //     },
    //     decode(e: any) {
    //         let t = '', n, r, i, s, o, u, a, f = 0;
    //         e = e.replace(/[^A-Za-z0-9+/=]/g, '');
    //         while (f < e.length) {
    //             s = this._keyStr.indexOf(e.charAt(f++));
    //             o = this._keyStr.indexOf(e.charAt(f++));
    //             u = this._keyStr.indexOf(e.charAt(f++));
    //             a = this._keyStr.indexOf(e.charAt(f++));
    //             n = s << 2 | o >> 4;
    //             r = (o & 15) << 4 | u >> 2;
    //             i = (u & 3) << 6 | a;
    //             t = t + String.fromCharCode(n);
    //             if (u != 64) {
    //                 t = t + String.fromCharCode(r);
    //             }
    //             if (a != 64) {
    //                 t = t + String.fromCharCode(i);
    //             }
    //         }
    //         t = this._utf8_decode(t);
    //         return t;
    //     },
    //     _utf8_encode(e: any) {
    //         let t = '';
    //         e = e.replace(/rn/g, 'n');
    //         for (let n = 0; n < e.length; n++) {
    //             let r = e.charCodeAt(n);
    //             if (r < 128) {
    //                 t += String.fromCharCode(r);
    //             } else if (r > 127 && r < 2048) {
    //                 t += String.fromCharCode(r >> 6 | 192);
    //                 t += String.fromCharCode(r & 63 | 128);
    //             } else {
    //                 t += String.fromCharCode(r >> 12 | 224);
    //                 t += String.fromCharCode(r >> 6 & 63 | 128);
    //                 t += String.fromCharCode(r & 63 | 128);
    //             }
    //         }
    //         return t;
    //     },
    //     _utf8_decode(e: any) {
    //         let t = '', n = 0, r = 0, c1 = 0, c2 = 0;
    //         while (n < e.length) {
    //             r = e.charCodeAt(n);
    //             if (r < 128) {
    //                 t += String.fromCharCode(r);
    //                 n++;
    //             } else if (r > 191 && r < 224) {
    //                 c1 = e.charCodeAt(n + 1);
    //                 t += String.fromCharCode((r & 31) << 6 | c1 & 63);
    //                 n += 2;
    //             } else {
    //                 c1 = e.charCodeAt(n + 1);
    //                 c2 = e.charCodeAt(n + 2);
    //                 t += String.fromCharCode((r & 15) << 12 | (c1 & 63) << 6 | c2 & 63);
    //                 n += 3;
    //             }
    //         }
    //         return t;
    //     },
    // },

    // dateReviver(key: any, value: any) {
    //     let a;
    //     if (typeof value === 'string') {
    //         a = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
    //         if (a) {
    //             return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4], +a[5], +a[6]));
    //         }
    //     }
    //     return value;
    // },

    // // taken from: https://github.com/lgalfaso/angular-dynamic-locale
    // loadScript(url: string, callback: Function, errorCallback: Function) {
    //     const script: any = document.createElement('script');
    //     const body = document.getElementsByTagName('body')[0];
    //     let removed = false;

    //     script.type = 'text/javascript';
    //     if (script.readyState) { // IE <= 10
    //         script.onreadystatechange = () => {
    //             if (script.readyState === 'complete' || script.readyState === 'loaded') {
    //                 script.onreadystatechange = null;
    //                 window.setTimeout(() => {
    //                     if (removed) {
    //                         return;
    //                     }
    //                     removed = true;
    //                     body.removeChild(script);
    //                     callback();
    //                 }, 30, false);
    //             }
    //         };
    //     } else { // Others
    //         script.onload = () => {
    //             if (removed) {
    //                 return;
    //             }
    //             removed = true;
    //             body.removeChild(script);
    //             callback();
    //         };
    //         script.onerror = () => {
    //             if (removed) {
    //                 return;
    //             }
    //             removed = true;
    //             body.removeChild(script);
    //             errorCallback();
    //         };
    //     }
    //     script.src = url;
    //     script.async = false;
    //     body.appendChild(script);
    // },

    // areEqual(obj1: any, obj2: any) {
    //     if (!obj1 && !obj2) {
    //         return true;
    //     }
    //     if ((obj1 && !obj2) || (!obj1 && obj2)) {
    //         return false;
    //     }
    //     return Object.keys(obj1).every((key) => obj2.hasOwnProperty(key) && (obj1[key] === obj2[key]));
    // },

    // // taken from: https://github.com/William17/list-to-tree-lite
    // listToTree(data: any[], options: ListToTreeOptions) {
    //     options = options || {};
    //     const ID_KEY = options.idKey || 'id';
    //     const PARENT_KEY = options.parentKey || 'parent';
    //     const CHILDREN_KEY = options.childrenKey || 'children';

    //     const tree = [];
    //     const childrenOf = {} as any;
    //     let item;
    //     let id;
    //     let parentId;

    //     for (let i = 0, length = data.length; i < length; i++) {
    //         item = data[i];
    //         id = item[ID_KEY];
    //         parentId = item[PARENT_KEY] || 0;
    //         // every item may have children
    //         childrenOf[id] = childrenOf[id] || [];
    //         // init its children
    //         item[CHILDREN_KEY] = childrenOf[id];
    //         if (parentId != 0) {
    //             // init its parent's children object
    //             childrenOf[parentId] = childrenOf[parentId] || [];
    //             // push it into its parent's children object
    //             childrenOf[parentId].push(item);
    //         } else {
    //             tree.push(item);
    //         }
    //     }

    //     return tree;
    // },

    // isoNum(n: number): string {
    //     const date = new Date();
    //     const tzoffset = date.getTimezoneOffset() * 60000; // offset in milliseconds
    //     const localIsoTime = (new Date(date as any - tzoffset)).toISOString().slice(0, -1);
    //     return localIsoTime.replace(/[-T:\.Z]/g, '').substring(0, n || 20); // YYYYMMDD
    // },

    /**
     * Converts an object into a key/value par with an optional prefix. Used for converting objects to a query string.
     * @constructor
     * @param {string} obj - The object to iterate to.
     * @param {string} prefix - The option prefix.
     */
    toQueryString(obj: any, prefix?: string): string {
        return this._toQueryStringArray(obj, prefix).join('&');
    },

    /**
     * Converts an object array into a key/value par with an optional prefix. Used for converting list of objects to a query string with asp.net mvc model binder default convention.
     * @constructor
     * @param {string} obj - The object to iterate to.
     * @param {string} prefix - The option prefix.
     */
    toQueryStringMultiple(obj: any[], prefix?: string): string { 
        const query = [];
        for (let i = 0; i < obj.length; i++) {
            for (const queryItem of utilityService._toQueryStringArray(obj[i], prefix)) {
                query.push(`[${i}].${queryItem}`);
            }
        }
        return query.join('&');
    },

    _toQueryStringArray(obj: any, prefix?: string): string[] {
        const items = [];
        for (const p in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, p)) {
                const k = prefix ? prefix + '[' + p + ']' : p;
                const v = obj[p];
                items.push(v !== null && v !== undefined && !(v instanceof Date) && typeof v === 'object'
                    ? this.toQueryString(v, k)
                    : encodeURIComponent(k) + '=' + (v !== null && v !== undefined
                        ? encodeURIComponent(v instanceof Date
                            ? v.toISOString() // convert date to string
                            : v.toString())
                        : '')); // do not pass nulls as string in the URL
            }
        }
        return items;
    },

    b64toBlob(b64Data: string, contentType: string, sliceSize: number): Blob {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            byteArrays.push(new Uint8Array(byteNumbers));
        }

        return new Blob(byteArrays, { type: contentType });
    }

}
